
export const MORTGAGE_CUSTOMER_SERVICE_RAW = '8662586572';

export const MORTGAGE_CUSTOMER_SERVICE_DISPLAY = '(866) 258-6572';

export const MORTGAGE_CUSTOMER_SERVICE_TEL = 'tel:+18662586572';

export const HELOC_CUSTOMER_SERVICE_RAW = '8667904254';

export const HELOC_CUSTOMER_SERVICE_DISPLAY = '(866) 790-4254';

export const HELOC_CUSTOMER_SERVICE_TEL = 'tel:+18667904254';

export const VA_CUSTOMER_SERVICE_RAW = '8445022852';

export const VA_CUSTOMER_SERVICE_DISPLAY = '(844) 502-2852';

export const VA_CUSTOMER_SERVICE_TEL = 'tel:+18445022852';

export const LOANDEPOT_SUPPORT_RAW = '8883376888';

export const LOANDEPOT_SUPPORT_DISPLAY = '1-888-337-6888';

export const LOANDEPOT_SUPPORT_TEL = 'tel:+18883376888';

export const ORIGINATION_SUPPORT_RAW = '8554143319';

export const ORIGINATION_SUPPORT_DISPLAY = '(855) 414-3319';

export const ORIGINATION_SUPPORT_TEL = 'tel:+18554143319';

export const TEXAS_CONSUMER_HOTLINE_RAW = '8772765550';

export const TEXAS_CONSUMER_HOTLINE_DISPLAY = '1-877-276-5550';

export const TEXAS_CONSUMER_HOTLINE_TEL = 'tel:+18772765550';

export const NY_DFS_CONSUMER_RAW = '8003423736';

export const NY_DFS_CONSUMER_DISPLAY = '1-800-342-3736';

export const NY_DFS_CONSUMER_TEL = 'tel:+18003423736';

export const TECHNICAL_SUPPORT_RAW = '8669707105';

export const TECHNICAL_SUPPORT_DISPLAY = '866-970-7105';

export const TECHNICAL_SUPPORT_TEL = 'tel:+18669707105';

export const CUSTOMER_SERVICE_HOURS = {
  weekday: {
    days: 'Mon - Fri',
    hours: '7:00AM - 7:00PM CST',
  },
  saturday: {
    days: 'Sat',
    hours: '8:00AM - 5:00PM CST',
  },
} as const;

export type CustomerServiceLoanCategory = 'VA' | 'HELOC' | 'MORTGAGE';

export function getCustomerServicePhone(loanCategory: CustomerServiceLoanCategory): string {
  switch (loanCategory) {
    case 'VA':
      return VA_CUSTOMER_SERVICE_DISPLAY;
    case 'HELOC':
      return HELOC_CUSTOMER_SERVICE_DISPLAY;
    default:
      return MORTGAGE_CUSTOMER_SERVICE_DISPLAY;
  }
}

export function getCustomerServiceTel(loanCategory: CustomerServiceLoanCategory): string {
  switch (loanCategory) {
    case 'VA':
      return VA_CUSTOMER_SERVICE_TEL;
    case 'HELOC':
      return HELOC_CUSTOMER_SERVICE_TEL;
    default:
      return MORTGAGE_CUSTOMER_SERVICE_TEL;
  }
}
